import { Injectable } from '@angular/core';
import {Md5} from 'ts-md5/dist/md5';

@Injectable({
  providedIn: 'root'
})
export class EncryptPwdService {

  constructor() { }

  encryptUsingAES256(pwd) {
    const md5 = new Md5();
    return md5.appendStr(pwd).end()
  }
  decryptUsingAES256() {
    // this.decrypted = CryptoJS.enc.Base64.parse(this.responce);
  }
}
